/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Posts_PublisherInputs */

const id_misc_posts_publisher = /** @type {(inputs: Misc_Posts_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warner Bros.`)
};

const ms_misc_posts_publisher = /** @type {(inputs: Misc_Posts_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warner Bros.`)
};

const da_misc_posts_publisher = /** @type {(inputs: Misc_Posts_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warner Bros.`)
};

const de_misc_posts_publisher = /** @type {(inputs: Misc_Posts_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warner Bros.`)
};

const en_us2_misc_posts_publisher = /** @type {(inputs: Misc_Posts_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warner Bros.`)
};

const es_es2_misc_posts_publisher = /** @type {(inputs: Misc_Posts_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warner Bros.`)
};

const es_mx2_misc_posts_publisher = /** @type {(inputs: Misc_Posts_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warner Bros.`)
};

const fil_misc_posts_publisher = /** @type {(inputs: Misc_Posts_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warner Bros.`)
};

const fr_misc_posts_publisher = /** @type {(inputs: Misc_Posts_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warner Bros.`)
};

const it_misc_posts_publisher = /** @type {(inputs: Misc_Posts_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warner Bros.`)
};

const hu_misc_posts_publisher = /** @type {(inputs: Misc_Posts_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warner Bros.`)
};

const nl_misc_posts_publisher = /** @type {(inputs: Misc_Posts_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warner Bros.`)
};

const no_misc_posts_publisher = /** @type {(inputs: Misc_Posts_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warner Bros.`)
};

const pl_misc_posts_publisher = /** @type {(inputs: Misc_Posts_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warner Bros.`)
};

const pt_br2_misc_posts_publisher = /** @type {(inputs: Misc_Posts_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warner Bros.`)
};

const pt_misc_posts_publisher = /** @type {(inputs: Misc_Posts_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warner Bros.`)
};

const ro_misc_posts_publisher = /** @type {(inputs: Misc_Posts_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warner Bros.`)
};

const fi_misc_posts_publisher = /** @type {(inputs: Misc_Posts_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warner Bros.`)
};

const sv_misc_posts_publisher = /** @type {(inputs: Misc_Posts_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warner Bros.`)
};

const vi_misc_posts_publisher = /** @type {(inputs: Misc_Posts_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warner Bros.`)
};

const tr_misc_posts_publisher = /** @type {(inputs: Misc_Posts_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warner Bros.`)
};

const cs_misc_posts_publisher = /** @type {(inputs: Misc_Posts_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warner Bros.`)
};

const bg_misc_posts_publisher = /** @type {(inputs: Misc_Posts_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warner Bros.`)
};

const ru_misc_posts_publisher = /** @type {(inputs: Misc_Posts_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warner Bros.`)
};

const uk_misc_posts_publisher = /** @type {(inputs: Misc_Posts_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warner Bros.`)
};

const ar_misc_posts_publisher = /** @type {(inputs: Misc_Posts_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warner Bros.`)
};

const hi_misc_posts_publisher = /** @type {(inputs: Misc_Posts_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warner Bros.`)
};

const th_misc_posts_publisher = /** @type {(inputs: Misc_Posts_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warner Bros.`)
};

const ja_misc_posts_publisher = /** @type {(inputs: Misc_Posts_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warner Bros.`)
};

const zh_cn2_misc_posts_publisher = /** @type {(inputs: Misc_Posts_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`华纳兄弟`)
};

const zh_hant1_misc_posts_publisher = /** @type {(inputs: Misc_Posts_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`華納兄弟`)
};

const ko_misc_posts_publisher = /** @type {(inputs: Misc_Posts_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warner Bros.`)
};

/**
* | output |
* | --- |
* | "Warner Bros." |
*
* @param {Misc_Posts_PublisherInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_publisher = /** @type {((inputs?: Misc_Posts_PublisherInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_PublisherInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_publisher(inputs)
	if (locale === "ms") return ms_misc_posts_publisher(inputs)
	if (locale === "da") return da_misc_posts_publisher(inputs)
	if (locale === "de") return de_misc_posts_publisher(inputs)
	if (locale === "en-US") return en_us2_misc_posts_publisher(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_publisher(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_publisher(inputs)
	if (locale === "fil") return fil_misc_posts_publisher(inputs)
	if (locale === "fr") return fr_misc_posts_publisher(inputs)
	if (locale === "it") return it_misc_posts_publisher(inputs)
	if (locale === "hu") return hu_misc_posts_publisher(inputs)
	if (locale === "nl") return nl_misc_posts_publisher(inputs)
	if (locale === "no") return no_misc_posts_publisher(inputs)
	if (locale === "pl") return pl_misc_posts_publisher(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_publisher(inputs)
	if (locale === "pt") return pt_misc_posts_publisher(inputs)
	if (locale === "ro") return ro_misc_posts_publisher(inputs)
	if (locale === "fi") return fi_misc_posts_publisher(inputs)
	if (locale === "sv") return sv_misc_posts_publisher(inputs)
	if (locale === "vi") return vi_misc_posts_publisher(inputs)
	if (locale === "tr") return tr_misc_posts_publisher(inputs)
	if (locale === "cs") return cs_misc_posts_publisher(inputs)
	if (locale === "bg") return bg_misc_posts_publisher(inputs)
	if (locale === "ru") return ru_misc_posts_publisher(inputs)
	if (locale === "uk") return uk_misc_posts_publisher(inputs)
	if (locale === "ar") return ar_misc_posts_publisher(inputs)
	if (locale === "hi") return hi_misc_posts_publisher(inputs)
	if (locale === "th") return th_misc_posts_publisher(inputs)
	if (locale === "ja") return ja_misc_posts_publisher(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_publisher(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_publisher(inputs)
	return ko_misc_posts_publisher(inputs)
});
export { misc_posts_publisher as "misc.posts.publisher" }